/* eslint-disable prettier/prettier */
import React from 'react';

import { getLayoutClass } from '@/helpers/HtmlHelper/getLayoutClass';

type TProps = {
  layout: string;
};
export function SkeletonTemplate2({ layout }: TProps) {
  return (
    <section className={getLayoutClass('2', layout)} data-testid="skeleton">
      <div className="vitrine-template2__skeleton">
        <div className="vitrine-template2__skeleton--line-1" />
        <div className="vitrine-template2__skeleton--line-2" />
        <div className="vitrine-template2__skeleton--line-3" />
        <div className="vitrine-template2__skeleton--cards">
          <div className="vitrine-template2__skeleton--round-1" />
          <div className="vitrine-template2__skeleton--round-2" />
          {['1', '2', '3', '4'].map(value => (
            <div key={value} className="vitrine-template2__skeleton--card">
              <div className="vitrine-template2__skeleton--card-left" />
              <div className="vitrine-template2__skeleton--card-right" />
              <div className="vitrine-template2__skeleton--card-lines">
                <div className="vitrine-template2__skeleton--card-line-1" />
                <div className="vitrine-template2__skeleton--card-line-2" />
                <div className="vitrine-template2__skeleton--card-line-3" />
                <div className="vitrine-template2__skeleton--card-line-4" />
              </div>
            </div>
          ))}
        </div>
        <div className="vitrine-template2__skeleton--footer">
          <div className="vitrine-template2__skeleton--line-4" />
          <div className="vitrine-template2__skeleton--line-5" />
        </div>
      </div>
    </section>
  );
}
